import {
  authControllerLoginV1,
  authControllerChildLoginV1,
  authControllerRefreshV1,
  authControllerLogoutV1,
  authControllerMeV1,
  authControllerCsrfTokenV1,
  authControllerChangePasswordV1,
  authControllerSetMyLocaleV1,
  authControllerRequestPasswordResetV1,
  authControllerResetPasswordV1,
  authControllerVerifyEmailV1,
  type LoginDto,
  type ChildLoginDto,
  type ChangePasswordDto,
  type RequestPasswordResetDto,
  type ResetPasswordDto,
  type SessionResponse,
  type AuthTokenResponse,
  type MeResponse,
  type CsrfResponse,
} from '@kidshome/api-contract';

/**
 * Auth API — thin typed wrappers over the GENERATED client functions (the only API access path).
 * The generated functions now carry real response types (from the OpenAPI response schemas), so
 * these wrappers reuse them directly. The HTTP itself still goes through the generated function +
 * the shared mutator — no hand-written fetch.
 */

export const login = (dto: LoginDto): Promise<SessionResponse> => authControllerLoginV1(dto);

// Public self-registration was removed (ADR-0072): households are provisioned by a super-admin who
// emails the first parent an invite; the parent claims it via the accept-invite flow.

export const childLogin = (dto: ChildLoginDto): Promise<SessionResponse> =>
  authControllerChildLoginV1(dto);

export const refresh = (): Promise<AuthTokenResponse> => authControllerRefreshV1();

export const logout = (): Promise<void> => authControllerLogoutV1();

export const fetchMe = (): Promise<MeResponse> => authControllerMeV1();

export const fetchCsrfToken = (): Promise<CsrfResponse> => authControllerCsrfTokenV1();

export const changePassword = (dto: ChangePasswordDto): Promise<void> =>
  authControllerChangePasswordV1(dto);

/** Request a password-reset link by email (public; always resolves — no account enumeration). */
export const requestPasswordReset = (dto: RequestPasswordResetDto): Promise<void> =>
  authControllerRequestPasswordResetV1(dto);

/** Redeem a password-reset token + set a new password (public). */
export const resetPassword = (token: string, dto: ResetPasswordDto): Promise<void> =>
  authControllerResetPasswordV1(token, dto);

/** Redeem an email-verification token (public). */
export const verifyEmail = (token: string): Promise<void> => authControllerVerifyEmailV1(token);

/**
 * Persist the CALLER's own locale (self-service `PUT /v1/auth/me/locale` — no admin permission and
 * no target id, so any member incl. a child/relative can save their language). `locale: null` clears
 * the override so the member inherits the household default.
 */
export const persistMyLocale = (locale: string | null): Promise<void> =>
  authControllerSetMyLocaleV1({ locale });
